import useTenantDomain from './useTenantDomain';
export * from './useTenantDomain';
export default useTenantDomain;
